/*
 * @Description: 
 * @Version: 2.0
 * @Author: zhouhong07
 * @Date: 2020-02-08 12:21:22
 * @LastEditors  : zhouhong07
 * @LastEditTime : 2020-02-14 17:43:47
 */

import React, { useEffect } from 'react' ;
import { Link } from 'react-router-dom' ;
import { getCid } from '../../util/helper';
import { Log } from '../../util/empty' ;
import Cookie from '../../util/cookie';

const SelfBlock = (props) => {
  const addempty = () => {
    Log(`cfCityClick_${props.data.id}`) ;
  }
  const getCurid = () => {
   let city = Cookie.get('commontopbar_ipcity') ? decodeURI(Cookie.get('commontopbar_ipcity')).split("|")[0] : "bj" ;
   return city ;
  }

  return(
    <div className="self-block" onClick={addempty}>
      <a href={`//hrgnode.58.com/zcm/springpc/#/maincity:${props.data.id}_${props.data.name}_${props.data.c_name}`} target="_blank">
      <div className="self-block-left">
      </div>
      <div className="self-block-right">
        <p className="self-name">{props.data.name}</p>
        <p className="self-intro"> 招聘专场> </p>
      </div>
      {
        getCurid() == props.data.c_name ? <div className="tips-curcity">当前城市</div> : "" 
      }
      </a>
    </div>
  )
}

export default SelfBlock ;